var $edc7c66594a0ae8a$exports = {};
$edc7c66594a0ae8a$exports = {
    "longPressMessage": `Premere a lungo o premere Alt + Freccia gi\xf9 per aprire il menu`
};


export {$edc7c66594a0ae8a$exports as default};
//# sourceMappingURL=it-IT.module.js.map
